import { useEffect, useRef } from 'react';

const handlers = [];

export const dismissNativeOverlay = () => {
  const handler = handlers[handlers.length - 1];
  if (!handler) return false;
  handler();
  return true;
};

// The last mounted overlay gets the first chance to handle Android back.
export default function useNativeBack(open, onClose) {
  const closeRef = useRef(onClose);
  closeRef.current = onClose;
  useEffect(() => {
    if (!open) return undefined;
    const handler = () => closeRef.current?.();
    handlers.push(handler);
    return () => {
      const index = handlers.indexOf(handler);
      if (index !== -1) handlers.splice(index, 1);
    };
  }, [open]);
}
